import { render, staticRenderFns } from "./ModalProcessoHistorico.vue?vue&type=template&id=7de49c3c&scoped=true"
import script from "./ModalProcessoHistorico.vue?vue&type=script&lang=js"
export * from "./ModalProcessoHistorico.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoHistorico.vue?vue&type=style&index=0&id=7de49c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de49c3c",
  null
  
)

export default component.exports